import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const QuoteLineItemInput = () => {
  const { lineItemId = '' } = useParams();
  const decodedId = lineItemId ? atob(lineItemId) : lineItemId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'quoteLineItem';

  useEffect(() => {
    if (lineItemId) { setIsEditing(true); fetchDetails(); }
  }, [lineItemId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.quoteLineItem}${id}/`, { headers });
      setFormData(response.data);
    } catch (error) {
      console.error('Error fetching line item details:', error);
    }
  };

  const fields = [
    {
      name: 'quote', label: 'Quote', type: 'async-select',
      endpoint: API_ROUTES.quote,
      getOptionLabel: (q) => q.title || `Quote #${q.id}`,
    },
    {
      name: 'product', label: 'Product', type: 'async-select',
      endpoint: API_ROUTES.products,
      getOptionLabel: (p) => p.name,
    },
    { name: 'quantity', label: 'Quantity', type: 'number' },
    { name: 'unit_price', label: 'Unit Price', type: 'number' },
    { name: 'discount', label: 'Discount (%)', type: 'number' },
    { name: 'notes', label: 'Notes', type: 'textarea' },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Quote Line Item' : 'Create Quote Line Item'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} />
    </div>
  );
};

export default QuoteLineItemInput;
